<div class="flex flex-col gap-y-4 w-full">
  <div class="flex justify-between">
    <div class="text-(--color-text-primary) font-semibold text-2xl">
      {{ 'servicesTable.title' | translate }}
    </div>

    <button
      (click)="closeModal()"
      class="border! rounded-full border-(--comp-dialog-button-close)!"
      mat-icon-button
    >
      <mat-icon class="text-(--comp-dialog-button-close)!">close</mat-icon>
    </button>
  </div>

  <div class="flex flex-col gap-y-2 w-full">
    <app-table-general
      class="col-span-full"
      [dataSource]="dataSource"
      [isLoading]="loadService"
      [headers]="headers"
      [isSticky]="true"
      [isStickyEnd]="true"
    ></app-table-general>

    <mat-paginator
      [length]="dataSourceOrigen.length || 0"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50]"
      (page)="onPageChange($event.pageIndex)"
      [attr.aria-label]="'common.accessibility.selectPage' | translate"
    >
    </mat-paginator>
  </div>
</div>

@if (loadService) {
  <app-load-general [load]="loadService"></app-load-general>
}
